import * as angular from 'angular';
import CityHomeIndexComponent from './city-home-index.component';
import CityHomeLandingPageComponent from './city-home-landing-page.component';
export default angular.module('city-home', [])
  .component('cityHomeIndex', CityHomeIndexComponent)
  .component('cityHomeLandingPage', CityHomeLandingPageComponent)
  .name;
